import Base64 from '../base64';

window.Base64 = Base64;

export default Base64;
